import * as React from "react";
import { connect } from "react-redux";

interface LoggedInUserProps {
    user: User;
}

interface LoggedInUserState
{
    user: User;
    page: string;
}

class LoggedInUser extends React.Component<LoggedInUserProps, LoggedInUserState>
{
    render(): React.ReactNode
    {
        return <React.Fragment>
            <span>{this.props.user.fullName}</span>
        </React.Fragment>;
    }
}

const mapStateToProps = (state: any) => ({
    user: state.app.user,
    page: state.app.page
});

export default connect(mapStateToProps)(LoggedInUser);